/**
 * Pixel rect (in container space) where `object-fit: contain` draws an image
 * of intrinsic size (contentW × contentH) inside a container (containerW × containerH).
 *
 * @param {number} containerW
 * @param {number} containerH
 * @param {number} contentW
 * @param {number} contentH
 * @returns {{ x: number, y: number, width: number, height: number }}
 */
function objectFitContainRect(containerW, containerH, contentW, contentH) {
  if (
    typeof containerW !== 'number' ||
    typeof containerH !== 'number' ||
    typeof contentW !== 'number' ||
    typeof contentH !== 'number' ||
    containerW <= 0 ||
    containerH <= 0 ||
    contentW <= 0 ||
    contentH <= 0
  ) {
    throw new Error('objectFitContainRect: dimensions must be positive numbers');
  }
  const arContent = contentW / contentH;
  const arContainer = containerW / containerH;
  let rw;
  let rh;
  let rx;
  let ry;
  if (arContent > arContainer) {
    rw = containerW;
    rh = containerW / arContent;
    rx = 0;
    ry = (containerH - rh) / 2;
  } else {
    rh = containerH;
    rw = containerH * arContent;
    rx = (containerW - rw) / 2;
    ry = 0;
  }
  return { x: rx, y: ry, width: rw, height: rh };
}

export { objectFitContainRect };
